import Vue from 'vue'

const Errors = new Vue()

export default Errors
